import { render, staticRenderFns } from "./ContactDataFields.vue?vue&type=template&id=178ee183&"
import script from "./ContactDataFields.vue?vue&type=script&lang=js&"
export * from "./ContactDataFields.vue?vue&type=script&lang=js&"
import style0 from "./ContactDataFields.vue?vue&type=style&index=0&id=178ee183&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QField,QInput,QBtn});
